import {
  DatasetsService,
  DebugService,
  IrbProtocolsService,
  KeywordsService,
  LabelsService,
  OrganizationsService,
  ProjectsService,
  StatusService,
  SystemUsageReportService,
  UsersService,
  VariablesMeasuredService,
} from '@backend';

export type ServiceClassMap = {
  DatasetsService: typeof DatasetsService;
  DebugService: typeof DebugService;
  IrbProtocolsService: typeof IrbProtocolsService;
  KeywordsService: typeof KeywordsService;
  LabelsService: typeof LabelsService;
  OrganizationsService: typeof OrganizationsService;
  ProjectsService: typeof ProjectsService;
  StatusService: typeof StatusService;
  SystemUsageReportService: typeof SystemUsageReportService;
  UsersService: typeof UsersService;
  VariablesMeasuredService: typeof VariablesMeasuredService;
};

export type ServiceInstanceMap = {
  DatasetsService: InstanceType<typeof DatasetsService>;
  DebugService: InstanceType<typeof DebugService>;
  IrbProtocolsService: InstanceType<typeof IrbProtocolsService>;
  KeywordsService: InstanceType<typeof KeywordsService>;
  LabelsService: InstanceType<typeof LabelsService>;
  OrganizationsService: InstanceType<typeof OrganizationsService>;
  ProjectsService: InstanceType<typeof ProjectsService>;
  StatusService: InstanceType<typeof StatusService>;
  SystemUsageReportService: InstanceType<typeof SystemUsageReportService>;
  UsersService: InstanceType<typeof UsersService>;
  VariablesMeasuredService: InstanceType<typeof VariablesMeasuredService>;
};

export const ServiceClasses: ServiceClassMap = {
  DatasetsService: DatasetsService,
  DebugService: DebugService,
  IrbProtocolsService: IrbProtocolsService,
  KeywordsService: KeywordsService,
  LabelsService: LabelsService,
  OrganizationsService: OrganizationsService,
  ProjectsService: ProjectsService,
  StatusService: StatusService,
  SystemUsageReportService: SystemUsageReportService,
  UsersService: UsersService,
  VariablesMeasuredService: VariablesMeasuredService,
};

export type OrgServiceInstanceMap = {[key: string]: ServiceInstanceMap};
